// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"b6966ec0","332":"41ae240d","404":"27a606ea","437":"6975c451"}[chunkId] + ".chunk.js";
};